import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import CustomerMessage from 'components/molecules/MessageTemplateSet/CustomerMessage';
import BotMessage from 'components/molecules/MessageTemplateSet/BotMessage';
import { useSelector } from 'react-redux';

/**
 * MessageDiv
 */
const MessageDiv = ({ message, index }) => {
  const fontSize = useSelector(state => state.fontSize);
  const { chatType, messageId, response_type } = message;

  const setItem = item => {
    try {
      if (chatType === 'customer') {
        const customerItem = {
          messageId: item.messageId,
          createAt: item.createAt,
          messages: item.messages,
        };
        return <CustomerMessage key={messageId} item={customerItem} boxStyle={{ fontSize }} />;
      }
      if (chatType === 'bot') {
        const botItem = {
          messageId: item.messageId,
          emotion: item.data.emotion,
          createAt: item.createAt,
          messages: item.data.speech,
          templateMessages: item.data.messages,
          status: item.data.response_status,
          customCode: item.data.custom_code,
          message_id: item.message_id,
          dialogue_id: item.dialogue_id,
          logo_flag: item.logo,
        };
        return <BotMessage key={messageId} item={botItem} responseType={response_type} boxStyle={{ fontSize }} index={index} />;
      }

      return false;
    } catch (e) {
      return false;
    }
  };

  return (
    <>
      {/* {dateSeperator && <MessageBeforeLine label={dateSeperator} />} */}
      <Element name={[messageId, ''].join('_')} style={{ display: 'flex' }}>
        {setItem(message)}
      </Element>
    </>
  );
};

MessageDiv.propTypes = {
  message: PropTypes.object,
  index: PropTypes.number,
};
MessageDiv.defaultProps = {
  message: {},
  index: 1,
};

export default MessageDiv;
